
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 47.4 131.2"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(.5 .5)"}},[_c('path',{staticClass:"st0",attrs:{"d":"M10.8 73.7l-.7 50.5c0 3.3 2.7 6 6 6s6-2.7 6-6V83.4h2.3v40.8c0 3.3 2.7 6 6 6s6-2.7 6-6l-.8-50.5H10.8z"}}),_c('circle',{staticClass:"st0",attrs:{"cx":"23.2","cy":"27.1","r":"10"}}),_c('path',{staticClass:"st0",attrs:{"d":"M46.1 61.5c-.6-5.8-1.8-12-5.1-16.9-1.2-1.7-2.7-3.2-3.9-4.2-.9-.8-2.1-1.2-3.3-1.2H16.7c-3.7 0-7-2.5-8-6-1-3.6-1.5-6.7-1.8-9.1-.4-3.3-.4-4.9-.3-7.3.1-4.2.7-8.4 1.8-12.5.4-1.6-.4-3.4-1.9-4C6.1.1 5.7 0 5.2 0 3.8 0 2.4 1 2 2.5.1 9.8-.4 17.3.3 24.7c.6 5.8 1.8 12 5.1 16.9 0 0 0 .1.1.1 3.4 4.9 5.3 10.7 5.3 16.7v13.2H35.5V47.3s.1-.1.1 0c2.4 6.1 3.4 11.3 3.8 14.9.4 3.3.4 4.9.3 7.3-.1 4.2-.7 8.3-1.7 12.5-.4 1.6.4 3.4 1.9 4 .4.2.9.3 1.3.3 1.5 0 2.8-1 3.2-2.5 1.9-7.4 2.4-14.8 1.7-22.3z"}})])])
          )
        }
      }
    